<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<h1>{{ locale.translations['user']['user-reset-password']['n246'] }}</h1>

<form [formGroup]="form">
	<ng-container *ngIf="visible; else showNumber">
		<p>
			{{ locale.translations['user']['user-verify']['n233'] }}
			<br />

			<span dir="ltr">{{ phone }}</span>
		</p>
		<!-- <p >
            {{ locale.translations['user']['user-verify']['n234'] } }
        </p> -->
		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell--span-12">
				<mat-form-field appearance="standard" hideRequiredMarker>
					<mat-label>{{ locale.translations['user']['user-verify']['n235'] }}</mat-label>

					<input matInput required minlength="6" maxlength="6" (keypress)="isNumberKey($event)" (keyup)="onKeyUp('otp')" formControlName="otp" />

					<mat-error *ngIf="!form.get('otp').valid">
						{{ locale.translations['user']['user-verify']['n234'] }}
					</mat-error>
				</mat-form-field>

				<span style="height: 1em; display: block">
					<a [routerLink]="['.']" [queryParams]="{ phone: phone }" (click)="resendOTP()" *ngIf="showResendOTP">
						{{ locale.translations['user']['user-verify']['n236'] }}
					</a>

					<span *ngIf="!showResendOTP" class="showResendOTPTimer">
						<div class="spinner preserve">
							<mat-progress-spinner mode="determinate" [value]="(showResendOTPTimer / 30) * 100" diameter="20"></mat-progress-spinner>
						</div>

						<span>{{ showResendOTPTimer }}</span>
					</span>
				</span>
			</div>

			<div class="mdc-layout-grid__cell--span-12">
				<button mat-flat-button color="primary" (click)="onCheckOtp()" [disabled]="!this.form.valid || loading">
					{{ locale.translations['logup']['n287'] }}
				</button>
			</div>

			<div id="sign-in-button"></div>
		</div>
	</ng-container>
</form>

<form [formGroup]="passwordForm">
	<ng-template #showNumber>
		<div class="mdc-layout-grid__cell--span-12">
			<mat-form-field appearance="standard" hideRequiredMarker>
				<mat-label>{{ locale.translations['user']['user-profile']['change-password']['n207'] }}</mat-label>

				<input
					matInput
					required
					[placeholder]="locale.translations['user']['user-profile']['change-password']['n203']"
					type="password"
					formControlName="newPassword"
				/>

				<mat-error *ngIf="!passwordForm.get('newPassword').valid">
					{{ locale.translations['user']['user-profile']['change-password']['n203'] }}
				</mat-error>
			</mat-form-field>
		</div>

		<div class="mdc-layout-grid__cell--span-12 mt-1">
			<mat-form-field appearance="standard" hideRequiredMarker>
				<mat-label>{{ locale.translations['user']['user-profile']['change-password']['n208'] }}</mat-label>

				<input
					matInput
					required
					[placeholder]="locale.translations['user']['user-profile']['change-password']['n205']"
					type="password"
					formControlName="confirmPassword"
				/>

				<mat-error *ngIf="!passwordForm.get('confirmPassword').valid">
					{{ locale.translations['user']['user-profile']['change-password']['n208'] }}
				</mat-error>
			</mat-form-field>
		</div>

		<div class="mdc-layout-grid__cell--span-12 mt-2">
			<button mat-flat-button (click)="changePassword()" color="primary" [disabled]="!passwordForm.valid || loading">
				{{ locale.translations['place-ad']['finish']['n77'] }}
			</button>
		</div>
	</ng-template>
</form>
